import { render, staticRenderFns } from "./CardDetailApp.vue?vue&type=template&id=0289f429&scoped=true&"
import script from "./CardDetailApp.vue?vue&type=script&lang=js&"
export * from "./CardDetailApp.vue?vue&type=script&lang=js&"
import style0 from "./CardDetailApp.vue?vue&type=style&index=0&id=0289f429&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0289f429",
  null
  
)

export default component.exports